// propertyNotesAPI.js
import { getToken } from "../../../utils/auth";
import { dev_baseUrl } from "../../../utils/var";
import { toast } from 'react-toastify';

export const GetPropertyNotes = async (jobID = 0, observationID = 0, workReqID) => {
  const accesstoken = getToken();
  
  if (!accesstoken) {
    console.warn("Access token is not available.");
    return [];
  }

  try {
    const response = await fetch(`${dev_baseUrl}/JobObservation/get?workReqID=${workReqID}&jobID=${jobID}&observationID=${observationID}`, {
      method: 'GET',
      headers: {
        'Authorization': `Bearer ${accesstoken}`,
        'Content-Type': 'application/json',
      },
    });

    const data = await response.json();

    if (response.ok && !data.isError) {
      return data;
    } else {
      console.error('Server error:', data);
      return [];
    }
  } catch (error) {
    console.error('Network error:', error);
    return [];
  }
};


export const SavePropertyNote = async (noteData) => {
  const accesstoken = getToken();

  if (!accesstoken) {
    console.warn("Access token is not available.");
    return;
  }

  try {
    const response = await fetch(`${dev_baseUrl}/JobObservation/save`, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${accesstoken}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(noteData),
    });

    const data = await response.json();

    // Handle the response format
    if (response.ok && !data.isError) {
      toast.success("Property note saved successfully", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: true,
        closeOnClick: false,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
              style: {
                fontFamily: '"DM Sans", sans-serif',
                fontSize: '15px',
              },
      });
      return data;
    }  
    
    if (response.ok && data.isError && data.result) {
      toast.error(data?.message || 'Unknown Error!', {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: true,
        closeOnClick: false,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
              style: {
                fontFamily: '"DM Sans", sans-serif',
                fontSize: '15px',
              },
      });
      return data.result[0];
    } else {
      toast.error(data?.message || 'Unknown Error!', {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: true,
        closeOnClick: false,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
              style: {
                fontFamily: '"DM Sans", sans-serif',
                fontSize: '15px',
              },
      });
      return data;
    }
  } catch (error) {
    console.error("Error during API call:", error);
    toast.error('API Error', {
      position: "top-right",
      autoClose: 5000,
      hideProgressBar: true,
      closeOnClick: false,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: "light",
              style: {
                fontFamily: '"DM Sans", sans-serif',
                fontSize: '15px',
              },
    });
    return;
  }
};

export const DeletePropertyNote = async (observationID, jobID) => {
  const accesstoken = getToken();

  if (!accesstoken) {
    console.warn("Access token is not available.");
    return;
  }

  try {
    const response = await fetch(`${dev_baseUrl}/JobObservation/delete?observationID=${observationID}&jobID=${jobID}`, {
      method: "DELETE",
      headers: {
        Authorization: `Bearer ${accesstoken}`,
        "Content-Type": "application/json",
      },
    });

    const data = await response.json();

    // Handle the response format
    if (response.ok && !data.isError) {
        toast.success("Property note deleted successfully", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: true,
          closeOnClick: false,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
              style: {
                fontFamily: '"DM Sans", sans-serif',
                fontSize: '15px',
              },
        });
      return data;
    }  
    
    if (response.ok && data.isError && data.result) {
      toast.error(data?.message || 'Unknown Error!', {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: true,
        closeOnClick: false,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
              style: {
                fontFamily: '"DM Sans", sans-serif',
                fontSize: '15px',
              },
      });
      return data.result[0];
    } else {
      toast.error(data?.message || 'Unknown Error!', {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: true,
        closeOnClick: false,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
         theme: "light",
              style: {
                fontFamily: '"DM Sans", sans-serif',
                fontSize: '15px',
              },
      });
      return data;
    }
  } catch (error) {
    console.error("Error during API call:", error);
    toast.error('API Error', {
      position: "top-right",
      autoClose: 5000,
      hideProgressBar: true,
      closeOnClick: false,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: "light",
              style: {
                fontFamily: '"DM Sans", sans-serif',
                fontSize: '15px',
              },
    });
    return;
  }
};